import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import EmailConfirmationModal from './EmailConfirmationModal';
import { get } from '../crud/user.crud';
import { checkCooldown } from '../crud/emailVerification.crud';
import * as authActions from '../store/ducks/auth.duck';
import styles from './EmailVerificationPopUp.module.css';
const InformationCircleIcon = '/icons/information-circle.svg';

function EmailVerificationPopUp() {
    const user = useSelector(({ auth: { user } }) => user);
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [showEmailModal, setShowEmailModal] = useState(false);
    const [hasFetchedProfile, setHasFetchedProfile] = useState(false);
    const [cooldownSeconds, setCooldownSeconds] = useState(0);

    // Buscar perfil atualizado quando o componente montar, se o usuário estiver logado
    useEffect(() => {
        if (user && user.id && !hasFetchedProfile) {
            setHasFetchedProfile(true);
            get(user.id)
                .then(({ data }) => {
                    if (data) {
                        dispatch(authActions.actions.fulfillUser(data));
                    }
                })
                .catch(() => {
                    // Silenciosamente ignora erros ao buscar perfil
                });
        }
    }, [user, hasFetchedProfile, dispatch]);

    useEffect(() => {
        if (!user) {
            setShowPopup(false);
            return;
        }

        const justRegistered = localStorage.getItem('justRegistered');
        if (justRegistered === 'true') {
            localStorage.removeItem('justRegistered');
            setShowPopup(false);
            return;
        }

        const emailVerified = user?.email_verified;
        const isVerified = emailVerified === true || 
                          emailVerified === 1 || 
                          emailVerified === '1';
        
        if (emailVerified !== undefined && emailVerified !== null) {
            setShowPopup(!isVerified);
        } else if (user?.email) {
            setShowPopup(true);
        } else {
            setShowPopup(false);
        }
    }, [user]);

    useEffect(() => {
        if (showPopup) {
            document.body.classList.add("has-email-verification");
            
            if (user?.email) {
                checkCooldown(user.email)
                    .then(({ data }) => {
                        if (data?.has_cooldown && data?.cooldown_seconds > 0) {
                            setCooldownSeconds(data.cooldown_seconds);
                        } else {
                            setCooldownSeconds(0);
                        }
                    })
                    .catch(() => {
                        setCooldownSeconds(0);
                    });
            }
        } else {
            document.body.classList.remove("has-email-verification");
        }

        return () => {
            document.body.classList.remove("has-email-verification");
        };
    }, [showPopup, user]);
    
    useEffect(() => {
        let interval = null;
        if (cooldownSeconds > 0) {
            interval = setInterval(() => {
                setCooldownSeconds((prev) => {
                    const newValue = prev - 1;
                    return newValue <= 0 ? 0 : newValue;
                });
            }, 1000);
        }
        return () => {
            if (interval) clearInterval(interval);
        };
    }, [cooldownSeconds]);

    const handleVerifyEmail = () => {
        if (!user?.email) {
            Swal.fire('Erro', 'Dados do usuário não encontrados.', 'error');
            return;
        }

        setShowEmailModal(true);
    };

    const handleEmailSent = () => {
        setShowEmailModal(false);
    };

    if (!showPopup) {
        return null;
    }

    return(
        <>
            <EmailConfirmationModal
                isOpen={showEmailModal}
                onClose={() => setShowEmailModal(false)}
                userEmail={user?.email}
                onEmailSent={handleEmailSent}
                user={user}
            />
            <div className={styles.emailVerificationPopUp}>
                <div className={styles.contentLeft}>
                    <div className={styles.iconContainer}>
                        <img src={InformationCircleIcon} alt="info" className={styles.iconSvg} />
                    </div>
                    <div className={styles.textContainer}>
                        <h2>Atenção: acesso em risco</h2>
                        <p>Confirme seu e-mail para evitar bloqueio do sistema.</p>
                    </div>
                </div>

                <div className={styles.contentRight}>
                    <button onClick={handleVerifyEmail} disabled={isLoading || cooldownSeconds > 0}>
                        {isLoading ? (
                            <i className='fa fa-spinner fa-spin' />
                        ) : cooldownSeconds > 0 ? (
                            `Aguarde ${Math.ceil(cooldownSeconds / 60)} minutos`
                        ) : (
                            'Confirmar agora'
                        )}
                    </button>
                </div>
            </div>
        </>
    )
}

export default EmailVerificationPopUp;
